import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Table } from "../../components";
import { useAppContext } from "../../context/state";
import { useRequest } from "../../utils";
import { useHistory } from "react-router-dom";
//locall
// import "./ShowComments.css";

const GetTerms = (props) => {
  let history = useHistory();

  const [
    get_terms_error,
    get_terms_loading,
    get_terms_data,
    get_terms_function,
  ] = useRequest({
    method: "post",
    url: "/get_terms",
    body: {
      product_id: props.match.params.id,
    },
  });

  return (
    <>
      {/* <!-- BEGIN: Content--> */}
      <div class="content-header row">
        <div class="content-header-left col-12 mb-2 mt-1">
          <div class="row breadcrumbs-top">
            <div class="col-12">
              <h5 class="content-header-title float-left pr-1">
                جدول های اطلاعاتی
              </h5>
              <div class="breadcrumb-wrapper">
                <ol class="breadcrumb p-0 mb-0">
                  <li class="breadcrumb-item">
                    <a href="index.html">
                      <i class="bx bx-home-alt"></i>
                    </a>
                  </li>
                  <li class="breadcrumb-item active">جدول اطلاعات</li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="content-body">
        <button
          onClick={() =>
            history.push("/dashboard/addTerm/" + props.match.params.id)
          }
          style={{ marginTop: "1rem", marginRight: "12px" }}
          type="button"
          class="btn btn-success mr-1 mb-1 "
        >
          افزودن ترم جدید
        </button>
        {/* <div class="row">
          <div class="col-12">
            <p>
              مستندات کامل را بخوانید در
              <a href="https://datatables.net/" target="_blank">
                اینجا
              </a>
            </p>
          </div>
        </div> */}
        {get_terms_data ? (
          <Table
            Thead={() => (
              <tr>
                <th className="table--title">نام ترم</th>
                {/* <th className="table--title">نام محصول</th>
                <th className="table--title">متن نظر</th>
                <th className="table--title">امتیاز</th>
                <th className="table--title">عملیات</th> */}
                <th className="table--title">عملیات</th>
              </tr>
            )}
            Tbody={() =>
              get_terms_data.data.map((item) => (
                <tr>
                  <td>{item.title}</td>
                  <td>
                    <Link
                      to={{
                        pathname:
                          "/dashboard/editTerm/" +
                          item._id +
                          "/term/" +
                          props.match.params.id,
                        query: { item },
                      }}
                    >
                      <button
                        type="button"
                        class="btn btn-warning round mr-1 mb-1 btn-sm"
                      >
                        ویرایش
                      </button>
                    </Link>
                    <Link
                      to={
                        "/dashboard/days/" +
                        item._id +
                        "/terms/" +
                        props.match.params.id
                      }
                    >
                      <button
                        type="button"
                        class="btn btn-dark round mr-1 mb-1 btn-sm"
                      >
                        روز ها
                      </button>
                    </Link>
                  </td>
                </tr>
              ))
            }
          />
        ) : null}
      </div>
      {/* <!-- END: Content--> */}
    </>
  );
};

export { GetTerms };
